import { isToolbarBodyActive } from './ToolbarStore';

export const updateToolbarBody = (value) => isToolbarBodyActive.update((oldValue) => value);
